import { useEffect, useRef, useState } from "react";
import { cn } from "@/lib/utils";
import { useIntroComplete } from "@/context/intro-state";

export default function TypedHandStyle({
  text,
  start = true,
  startDelayMs = 0,
  onDone,
  className,
  speedMultiplier = 1
}) {
  const [displayText, setDisplayText] = useState("");
  const [isTyping, setIsTyping] = useState(false);
  const timerRef = useRef(null);
  const introComplete = useIntroComplete();

  useEffect(() => {
    if (!start || !introComplete) {
      setDisplayText("");
      setIsTyping(false);
      return;
    }

    let cancelled = false;
    let index = 0;

    const run = () => {
      if (cancelled) return;

      if (index >= text.length) {
        setIsTyping(false);
        onDone?.();
        return;
      }

      index += 1;
      setDisplayText(text.slice(0, index));

      const ch = text[index - 1];
      const delay =
        ch === "\n"
          ? 140 + Math.floor(Math.random() * 70)
          : ch === " "
            ? 18 + Math.floor(Math.random() * 24)
            : 24 + Math.floor(Math.random() * 40);

      timerRef.current = window.setTimeout(run, Math.max(1, Math.floor(delay * speedMultiplier)));
    };

    timerRef.current = window.setTimeout(() => {
      if (cancelled) return;
      setDisplayText("");
      setIsTyping(true);
      run();
    }, startDelayMs);

    return () => {
      cancelled = true;
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [start, introComplete, text, startDelayMs, onDone, speedMultiplier]);

  return (
    <p className={cn("typed-hand", isTyping && "is-typing", className)}>
      {displayText}
      <span className={cn("typed-cursor", !isTyping && "hidden")} aria-hidden="true">
        |
      </span>
    </p>
  );
}
